import { Button, message } from 'antd';
import React, { ReactElement } from 'react';
import { COMMON_ERROR } from '../../constants/commonConstants';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';

export interface ICustomMessageNotification {
  message: string;
}
const CustomMessageNotification = ({message: textMsg}: ICustomMessageNotification): ReactElement => {
  if (textMsg === COMMON_ERROR) {
    customGTMEvent({
      event: 'Alert message when Something went wrong!',
    });
  }
  return (
    <React.Fragment>
      <span className="message-text">{textMsg}</span>
      <div className="text-right">
        <Button data-testid="close-custom-message-notification"
          className="p-0 h-auto" danger={true} type="text" onClick={(): any => message.destroy()}>
          Close
        </Button>
      </div>
    </React.Fragment>
  );
};
export default CustomMessageNotification;
